import styled from 'styled-components';

export const InfoListContainer = styled.ul<{itemCount: number}>`${({ theme, itemCount }) => `
    padding: 0;
    margin: 0;
    padding-left:${itemCount > 1 ? theme.padding[5] : 0};
    list-style: ${itemCount > 1 ? 'default' : 'none'};
`}`;

export const InfoListItem = styled.li`${({ theme }) => `
    margin: ${theme.padding[1]};
`}`;

export function InfoList({ items }: {items: string[]}) {
  return (
    <InfoListContainer itemCount={items.length}>
      {items.map((item) => (
        <InfoListItem key={item}>{item}</InfoListItem>
      ))}
    </InfoListContainer>
  );
}
